import { GridColDef } from "@mui/x-data-grid-premium";
import { prettyPrintEnumValue } from "encamp-shared/src/utils/prettyPrintEnumValue";
import { prettyPrintDateTime } from "util/dates";

/** Lean payment row shape shared by the fulfillment ticket's auxiliary payment tables. */
export type PaymentSectionRow = {
  id: string;
  payee?: string | null;
  paidAt: string;
  amount?: number | null;
  payeeType?: string | null;
  status: string;
  paymentMethod?: string | null;
};

/**
 * Column set shared by FacilityOnlyPaymentsSection and PaymentHistorySection
 * so the two tables cannot drift visually.
 */
export const paymentSectionColumns: GridColDef<PaymentSectionRow>[] = [
  {
    headerName: "Payment Date",
    field: "paidAt",
    flex: 1,
    renderCell: (p) => (p.value ? prettyPrintDateTime(p.value) : "Not paid"),
  },
  { headerName: "Payee", field: "payee", flex: 1 },
  { headerName: "Type", field: "payeeType", flex: 1 },
  {
    headerName: "Amount",
    field: "amount",
    flex: 1,
    valueFormatter: (value) =>
      new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(value ?? 0),
  },
  {
    headerName: "Method",
    field: "paymentMethod",
    flex: 1,
    renderCell: (p) => prettyPrintEnumValue(p.value),
  },
];
